const PAYMENT_METHOD = 'payment-method';
const PAYMENT_METHOD_CHECK = 'payment-method-check';
const PAYMENT_METHOD_CREDIT_CARD = 'payment-method-creditCard';

export { PAYMENT_METHOD, PAYMENT_METHOD_CHECK, PAYMENT_METHOD_CREDIT_CARD };
